import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useStore } from "../Store";

const InvalidLinkPage = () => {
  const { t } = useTranslation();
  const { casesStore } = useStore();

  useEffect(() => {
    casesStore.invalidateSession();
  }, [casesStore]);

  return <div role="alert" id="error-warning">{t("linkUnavailable")}</div>;
};

export default InvalidLinkPage;
